(() => {
  const readMoreLabels = {
    more: 'Read more',
    less: 'Read less',
  };
  const desktopHeaderMediaQuery = window.matchMedia('(min-width: 799px)');
  let desktopHeaderSyncTimer;

  function moveDesktopUtilities(root = document) {
    const desktopHeader = root.querySelector('[data-desktop-header]');
    if (!desktopHeader) return;

    const topBar = desktopHeader.querySelector('.header > .top-bar');
    const mainNav = desktopHeader.querySelector('.header > .main-nav__wrapper .main-nav');
    const utilities = topBar?.querySelector('.top-bar--right-menu');

    if (utilities && mainNav && !utilities.classList.contains('main-nav__utilities')) {
      utilities.classList.add('main-nav__utilities');
      mainNav.appendChild(utilities);
    }
  }

  function activateStickyHeader(root = document) {
    const stickyHeaders = root.querySelectorAll('.sticky_nav');
    if (!stickyHeaders.length) return;

    const stickyInstance = window.sticky_nav;
    if (stickyInstance?.stick) {
      // Keep Turbo's sticky controller in its native "stuck" state even at
      // scroll position zero so its animation and navigation lifecycle agree.
      stickyInstance.scrollOffset = -1;
      stickyInstance.stick();
    }

    stickyHeaders.forEach((stickyHeader) => {
      stickyHeader.classList.add('sticky_nav--stick');
      stickyHeader.classList.remove('sticky_nav--unstick');
      stickyHeader.dataset.animationState = 'open';

      const duplicateCart = stickyHeader.querySelector('.main-nav > .cart-container');
      duplicateCart?.remove();
    });
  }

  function resetMobileHeaderState() {
    document.body.classList.remove('is-active', 'mobile_nav-fixed--true', 'mobile_nav-fixed--false');

    const headerGroup = document.querySelector('.header-group');
    headerGroup?.classList.remove('sticky');
    headerGroup?.style.removeProperty('padding-bottom');

    const mobileHeader = document.querySelector('#header');
    mobileHeader?.style.removeProperty('top');
  }

  function ensureDesktopHeaderAfterResize(event) {
    if (!event.matches) return;

    window.clearTimeout(desktopHeaderSyncTimer);
    desktopHeaderSyncTimer = window.setTimeout(() => {
      if (!document.querySelector('.main-nav__wrapper.sticky_nav') && window.header?.init) {
        // Turbo keeps the destroyed desktop controller on window after it
        // initializes the mobile header. Avoid destroying that stale instance
        // a second time when crossing back to desktop.
        if (window.sticky_nav) window.sticky_nav = null;
        if (window.header.unload && window.mobileMenuDrawer) window.header.unload();
        resetMobileHeaderState();
        window.header.init();
      }

      moveDesktopUtilities();
      activateStickyHeader();
    }, 100);
  }

  function createFaqSummary(fullHtml, limit) {
    const summary = document.createElement('div');
    summary.className = 'faq-read-more__summary';
    summary.innerHTML = fullHtml;

    // The full answer remains in the DOM, so prevent duplicate fragment IDs in
    // the collapsed copy while retaining its paragraphs, lists, and line breaks.
    summary.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));

    let remainingWords = limit;
    let lastTextNode = null;
    let isTruncated = false;

    function truncateNode(node) {
      if (isTruncated || remainingWords === 0) {
        node.remove();
        isTruncated = true;
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const matches = [];
        const wordPattern = /\S+/g;
        let match = wordPattern.exec(node.textContent);

        while (match) {
          matches.push({ index: match.index, length: match[0].length });
          match = wordPattern.exec(node.textContent);
        }

        if (!matches.length) return;

        if (matches.length <= remainingWords) {
          remainingWords -= matches.length;
          lastTextNode = node;
          return;
        }

        const lastMatch = matches[remainingWords - 1];
        node.textContent = node.textContent
          .slice(0, lastMatch.index + lastMatch.length)
          .trimEnd();
        lastTextNode = node;
        remainingWords = 0;
        isTruncated = true;
        return;
      }

      Array.from(node.childNodes).forEach(truncateNode);
    }

    Array.from(summary.childNodes).forEach(truncateNode);

    Array.from(summary.querySelectorAll('*')).reverse().forEach((element) => {
      const containsVisibleMedia = element.matches('br, hr, img, svg, video, iframe')
        || element.querySelector('br, hr, img, svg, video, iframe');
      if (!element.textContent.trim() && !containsVisibleMedia) element.remove();
    });

    if (lastTextNode) {
      lastTextNode.textContent = `${lastTextNode.textContent.trimEnd()}\u2026`;
    }

    return summary;
  }

  function initializeFaqReadMore(root = document) {
    root.querySelectorAll('[data-faq-read-more]:not([data-read-more-ready])').forEach((container) => {
      const limit = Number.parseInt(container.dataset.wordLimit || '150', 10);
      const fullHtml = container.innerHTML.trim();
      const plainText = container.textContent.replace(/\s+/g, ' ').trim();
      const words = plainText.split(' ').filter(Boolean);

      container.dataset.readMoreReady = 'true';
      if (words.length <= limit) return;

      const summary = createFaqSummary(fullHtml, limit);

      const full = document.createElement('div');
      full.className = 'faq-read-more__full';
      full.hidden = true;
      full.innerHTML = fullHtml;

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'faq-read-more__toggle';
      toggle.textContent = readMoreLabels.more;
      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        toggle.textContent = expanded ? readMoreLabels.more : readMoreLabels.less;
        summary.hidden = !expanded;
        full.hidden = expanded;
      });

      container.replaceChildren(summary, full, toggle);
    });
  }

  function initializeLegacyFaqPage(root = document) {
    root.querySelectorAll('#disc-main:not([data-legacy-faq-ready])').forEach((faq) => {
      const answerColumn = Array.from(faq.children)
        .find((child) => child.classList.contains('one-col')) || faq.querySelector('.one-col');

      if (!answerColumn) return;

      Array.from(answerColumn.children).forEach((child) => {
        const isStandaloneBreak = child.tagName === 'BR';
        const isEmptySpacer = child.tagName === 'P'
          && !child.children.length
          && child.textContent.replace(/[\s\u00a0\u00c2]/g, '') === '';

        if (isStandaloneBreak || isEmptySpacer) child.remove();
      });

      const questionLinks = Array.from(faq.querySelectorAll('#faq a[rel]'));
      let answer = null;

      Array.from(answerColumn.childNodes).forEach((node) => {
        const heading = node.nodeType === Node.ELEMENT_NODE
          ? (node.matches('strong[class]') ? node : node.querySelector('strong[class]'))
          : null;
        const questionKey = heading
          ? Array.from(heading.classList).find((className) => /^q\d+$/i.test(className))
          : null;

        if (questionKey) {
          answer = document.createElement('div');
          answer.className = 'legacy-faq-answer';
          answer.id = `legacy-faq-${questionKey.toLowerCase()}`;
          answer.dataset.faqReadMore = '';
          answer.dataset.wordLimit = faq.dataset.wordLimit || '150';
          answerColumn.insertBefore(answer, node);

          const questionLink = questionLinks.find((link) => link.getAttribute('rel') === questionKey);
          if (questionLink && !questionLink.hasAttribute('href')) {
            questionLink.setAttribute('href', `#${answer.id}`);
          }
        }

        if (answer) answer.appendChild(node);
      });

      faq.dataset.legacyFaqReady = 'true';
    });
  }

  function initializePaymentTermsSpacing(root = document) {
    root.querySelectorAll('.product_form--payment-terms-below-cart:not([data-pono-payment-spacing])').forEach((productForm) => {
      const target = productForm.querySelector('[data-payment-terms-target]');
      if (!target) return;

      productForm.setAttribute('data-pono-payment-spacing', 'true');

      const syncVisibility = () => {
        const isVisible = target.style.display !== 'none' && target.querySelector('shopify-payment-terms');
        productForm.classList.toggle('payment-terms-visible', Boolean(isVisible));
      };

      new MutationObserver(syncVisibility).observe(target, {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
      });

      syncVisibility();
    });
  }

  function initialize(root = document) {
    moveDesktopUtilities(root);
    activateStickyHeader(root);
    initializeLegacyFaqPage(root);
    initializeFaqReadMore(root);
    initializePaymentTermsSpacing(root);
  }

  initialize();

  if (desktopHeaderMediaQuery.addEventListener) {
    desktopHeaderMediaQuery.addEventListener('change', ensureDesktopHeaderAfterResize);
  } else {
    desktopHeaderMediaQuery.addListener(ensureDesktopHeaderAfterResize);
  }

  const stickyObserver = new MutationObserver(() => activateStickyHeader());
  stickyObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
